import HtmlComponent from "./htmlParser";

var showdown = require("showdown");

interface Props {
  mdFile: string;
}

export const ConvertMdFile = ({ mdFile }: Props) => {
  const converter = new showdown.Converter();
  const htmlContent = converter.makeHtml(mdFile);

  return (
    <div>
      <HtmlComponent mdFile={htmlContent} />
    </div>
  );
};
